module.exports = __webpack_public_path__ + "static/img/girl.8c24fe8c.png";